import { useEffect } from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import Footer from "./Footer";
import { UPDATED } from "../data/legalContent";

const LegalPage = ({ content }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [content]);
  return (
  <div className="min-h-screen bg-white" data-testid="legal-page">
    <header className="border-b border-gray-100">
      <div className="mx-auto flex max-w-3xl items-center justify-between px-6 py-5">
        <Link to="/" aria-label="Accueil" data-testid="legal-home-logo">
          <Logo />
        </Link>
        <Link to="/" className="text-sm font-semibold text-[#189346] hover:underline" data-testid="legal-back-home">
          Retour à l’accueil
        </Link>
      </div>
    </header>
    <main className="mx-auto max-w-3xl px-6 py-12 sm:py-16">
      <h1 className="font-display text-4xl font-bold text-[#122118] sm:text-5xl" data-testid="legal-title">{content.title}</h1>
      <p className="mt-3 text-sm text-[#829C8D]">Dernière mise à jour : {content.updated || UPDATED}</p>
      <p className="mt-6 text-base leading-relaxed text-[#2d5a3d]">{content.intro}</p>
      {content.sections.map((section) => (
        <section key={section.title} className="mt-10">
          <h2 className="font-display text-base font-bold text-[#122118] md:text-lg">{section.title}</h2>
          <ul className="mt-3 space-y-2">
            {section.body.map((line) => (
              <li key={typeof line === "string" ? line : line.label} className="text-sm leading-relaxed text-[#4a5f53] sm:text-base">
                {typeof line === "string" ? line : (
                  <>
                    {line.prefix}
                    <Link to={line.to} className="font-medium text-[#189346] underline">{line.label}</Link>
                  </>
                )}
              </li>
            ))}
          </ul>
        </section>
      ))}
    </main>
    <Footer />
  </div>
  );
};

export default LegalPage;
